<template>
    <!-- модальное окно закрытия проекта -->
    <dialogBox @close="this.$emit('close')">
        <template v-slot:title>{{$t('confirmation')}}</template>
        <template v-slot:body>
            <div class="mb-3">
                <label  class="form-label">{{ $t('Comment') }}</label>
                <textarea class="form-control" rows="3" v-model="form.comment" :placeholder="$t('confirmation')"></textarea>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <button class="btn link-danger fw-medium" @click="this.$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('cancel') }} </button>
            <button 
                type="button" 
                class="btn btn-success" 
                @click="toClose()"
            >
                {{ $t('Add') }}
            </button>
        </template>
    </dialogBox>
</template>

<script>
import dialogBox from '@/components/modal/dialog'
import { Projects } from '@/API'
import { storeS } from '@/store'

let apiServe = new Projects();

export default {
    props: ['id'],
    components: {
        dialogBox
    },
    data(){
        return {
            form: {
                comment: "",
            },
        }
    },
    methods: {
        toClose(){
            apiServe.closeProject(this.id, this.form).then(result => {
                if(result.status == 'done'){
                    this.$toast.success(`done`);
                    this.eventBus.emit('closeProject', true);
                    this.$emit('close')
                } else if(result.status == 'error'){
                    this.$toast.error(result.error[0]);
                }
            })
        }
    }
}
</script>